module.exports = __webpack_public_path__ + "img/new-hander-logo.66020b0.png";